/**
 * **Mietbeginn in der Vergangenheit — nachträglich erfassen?** (Interview
 * F20 vom 04.10.2026, Befund V-45).
 *
 * Die Annahme antwortet mit `409 annahme.beginn_vergangen` und dem Tag, wenn
 * eine Miete vor heute beginnt. Das ist eine Rückfrage, kein Nein: Wer
 * wirklich nachträglich erfasst — der Bagger ist seit gestern draußen, der
 * Auftrag wird jetzt angelegt —, schickt dieselbe Anfrage mit
 * `nachtraeglich: true`. Ein Vertipper beim Datum fällt so auf, bevor drüben
 * eine Auftragsbestätigung entsteht.
 */

export const NACHTRAEGLICH_SCHLUESSEL = "annahme.beginn_vergangen";

/**
 * **Einmal bestätigt, gilt es für diesen Abschluss** (Prüfrunde Interview F,
 * F20-Rest, 05.10.2026). Nach „Ja, nachträglich erfassen" kam bei einem Kran
 * ohne Bediener „Wer fährt?" (F23); wer dort wählte und annahm, bekam die
 * Frage nach dem Mietbeginn ein zweites Mal — der zweite Aufruf ging ohne
 * `nachtraeglich`. Die Masken merken sich die Bestätigung und schicken sie
 * bei jedem weiteren Versuch mit.
 */
export function nachtraeglichSchicken(jetzt: boolean, schonBestaetigt: boolean): boolean {
  return jetzt || schonBestaetigt;
}

/** Ist dieser Fehler die Rückfrage „nachträglich erfassen?" */
export function istNachtraeglichFrage(fehler: unknown): boolean {
  return typeof fehler === "object" && fehler !== null
    && (fehler as { schluessel?: unknown }).schluessel === NACHTRAEGLICH_SCHLUESSEL;
}
